import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "sheet-head" }
const _hoisted_3 = { class: "sheet-title" }
const _hoisted_4 = { class: "sheet-body" }
const _hoisted_5 = { class: "sheet-foot" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "sheet" }, {
    default: _withCtx(() => [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "sheet-backdrop",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _createElementVNode("div", {
              class: "sheet",
              role: "dialog",
              "aria-label": _ctx.title
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
                _createElementVNode("button", {
                  class: "sheet-close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                  "aria-label": "Close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                }, "Cancel"),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-submit", _ctx.danger ? 'danger' : '']),
                  disabled: _ctx.busy,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('submit')))
                }, _toDisplayString(_ctx.busy ? 'Saving...' : _ctx.submitLabel), 11, _hoisted_6)
              ])
            ], 8, _hoisted_1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}